import React from 'react';
import { Divider } from 'rsuite';
import {BackIcon} from '../svg/iconsSvg';
import {FrameIconFP} from '../svg/iconFrameSvg';

const FPConfirmation = ({onBack, onForward, style}) => {

    const goBack = () => onBack(2);

    const goForward = () => onForward(1);

    return (
        <div className="steps_container" style={style}>
            <div className="head">
                <div className="head-icon" onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Забравена парола</h6>
            </div>
            <Divider />
            <div style={{textAlign: 'center', margin: '2rem 0'}}>
                <FrameIconFP />
            </div>
            <h6 className="text-main" style={{marginBottom: '70px'}}>Успешно променена парола</h6>

            <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" 
                        onClick={goForward} >Влез в профил</button>
        </div>
    )
}

export default FPConfirmation;